import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { BookingsComponent } from './bookings.component';
import { BookingsResolve } from './bookings.resolve';

@NgModule({
  imports: [
    RouterModule.forChild([
      {
        path: 'manage/admin/bookings',
        component: BookingsComponent,
        resolve: {
          portal: BookingsResolve,
        },
      },
    ]),
  ],
  exports: [RouterModule],
})
export class BookingsRoutingModule {}
